// AI1 fix (Aug 2026): product-modal.js does `class ProductModal extends ModalDialog`.
// ModalDialog is defined in global.js. On this store this file can execute BEFORE
// global.js has defined ModalDialog, which throws a ReferenceError so <product-modal>
// never registers and click-to-zoom fails with "modal.show is not a function".
// Fix: defer the definition until ModalDialog exists (retry on DOMContentLoaded/load,
// both of which fire after the deferred global.js has run). Dawn's logic is unchanged.
(function ai1DefineProductModal() {
  if (customElements.get('product-modal')) return;
  if (typeof ModalDialog === 'undefined') {
    document.addEventListener('DOMContentLoaded', ai1DefineProductModal, { once: true });
    window.addEventListener('load', ai1DefineProductModal, { once: true });
    return;
  }

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
})();
